import { Component, inject, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { TableComponent } from "src/app/table.component";
import { IssuanceModel } from "src/models/issuance";
import { DialogService } from "src/services/dialog.service";
import {
  CarePlusReportService,
  ReportRequestBody,
  RequestModel,
} from "src/services/reports/careplus-report.service";

@Component({
  selector: "app-request-reports",
  templateUrl: "./request-reports.component.html",
  styleUrls: ["./request-reports.component.css"],
})
export class RequestReportsComponent
  extends TableComponent<IssuanceModel>
  implements OnInit
{
  private _dialogService = inject(DialogService);
  requestList: RequestModel[] = [];
  dataSource: MatTableDataSource<RequestModel> = new MatTableDataSource();
  pageTitle = "Request Summary Report";
  startDate: Date;
  endDate: moment.Moment;
  get EndDate() {
    return this.endDate;
  }
  set EndDate(value) {
    if (value) {
      this.endDate = value.endOf("day");
    }
  }

  // displayedColumns: string[] = [
  //   "requestdate",
  //   "requestType",
  //   "customerID",
  //   "customerName",
  //   "basePremium",
  //   "totalIssueFee",
  //   "policyFee",
  //   "totalAmount",
  //   "amountPaid",
  //   "paymentReferenceNumber",
  //   "status",
  // ];
  displayedColumns: string[] = [
    "date",
    "numberOfRequests",
    "numberOfCustomers",
    "basePremium",
    "totalIssueFee",
    "policyFee",
    "totalAmount",
    "amountPaid",
  ];

  constructor(private reportService: CarePlusReportService) {
    super(reportService);
  }

  getCount() {
    const data = {
      startDate: this.startDate
        ? new Date(this.startDate).toISOString()
        : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined,
      skip: this.paginator?.pageIndex
        ? this.paginator.pageIndex * this.paginator.pageSize
        : 0,
      take: this.paginator?.pageSize ?? 0,
    };
    return this.reportService.getCount(data);
  }

  getData(): ReportRequestBody {
    return {
      startDate: this.startDate
        ? new Date(this.startDate).toISOString()
        : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined,
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      take: this.paginator.pageSize,
      asXLS: false,
    };
  }

  getDataByFilter() {
    this.getCount().subscribe((res) => {
      this.count = res.count;
      this.loadRequests();
    });
  }

  downloadXLS(isXLS: boolean) {
    const data = {
      startDate: this.startDate,
      endDate: this.endDate,
      skip: 0,
      take: 2147483647,
      asXLS: isXLS,
    };

    this.reportService.downloadReport(data, false);
  }

  getRequestsReport() {
    if (!this.startDate || !this.endDate) {
      this._dialogService.errorSanckBar(
        "Please select both start and end dates."
      );
      return;
    }

    const data: ReportRequestBody = this.getData();

    this.reportService.getData(data).subscribe({
      next: (res) => {
        this.requestList = res.map((item) => ({
          date: item.date,
          numberOfRequests: item.numberOfRequests,
          numberOfCustomers: item.numberOfCustomers,
          totalIssueFee: item.totalIssueFee,
          policyFee: item.policyFee,
          totalAmount: item.totalAmount,
          amountPaid: item.amountPaid,
          basePremium: item.basePremium,
        }));

        this.dataSource = new MatTableDataSource(this.requestList.reverse());
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
        }, 100);
      },
      error: (err) => {
        this._dialogService.errorSanckBar(
          err || "Something went wrong. Please contact admin."
        );
      },
    });
  }
}
